/*
PURPOSE: Global wrapper for ShareMusicPanel that connects to ShareMusicContext

USE CASES:
- Render ShareMusicPanel globally across authenticated routes
- Automatically configure panel based on context-specific settings
- Provide single source of truth for panel state management

DOMAIN BOUNDARIES:
- Responsible for connecting ShareMusicContext to ShareMusicPanel component
- Handles context-specific configuration passing to ShareMusicPanel
- Should NOT contain business logic for music resolution or content creation
- Acts as a bridge between global context and specific component

ASSUMPTIONS:
- Used within ShareMusicProvider to access context
- ShareMusicPanel component accepts configuration props
- Panel visibility is controlled by context state
*/

import React from 'react';
import { useShareMusicContext } from '../../contexts/ShareMusicContext';
import ShareMusicPanel from '../ShareMusicPanel/ShareMusicPanel';

const GlobalShareMusicPanel: React.FC = () => {
  const { isOpen, config, closePanel } = useShareMusicContext();

  if (!config) {
    return null;
  }

  return (
    <ShareMusicPanel
      isOpen={isOpen}
      onClose={closePanel}
      onContentCreated={config.onContentCreated}
      headerText={config.headerText}
      explainerText={config.explainerText}
      urlPlaceholder={config.urlPlaceholder}
      defaultContentType={config.defaultContentType}
    />
  );
};

export default GlobalShareMusicPanel;